import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Page,
  Button,
  Box,
} from '../../components';
import ContentForm from './ContentForm';
import DeleteContent from './DeleteContent';
import api from '../../utils/services';

const propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      carrierId: PropTypes.string,
      contentId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};
class EditContent extends Component {
  state = {
    deleteConfirmationOpen: false,
    deleteError: '',
  }

  handleDeleteContent = () => {
    const { match: { params: { contentId, carrierId } }, history } = this.props;
    api.deleteContent(contentId)
      .then(() => {
        if (carrierId) {
          history.push(`/carriers/${carrierId}/contents`);
        } else {
          history.push('/contents');
        }
      })
      .catch(() => {
        this.setState({ deleteError: 'Error deleting the content, try again later.' });
      });
  }

  handleCloseHandler = () => {
    this.setState({ deleteConfirmationOpen: false });
  }

  render() {
    const { match: { params: { contentId, carrierId } } } = this.props;
    const { deleteConfirmationOpen, deleteError } = this.state;

    let breadcrumbHref = `/contents/${contentId}`;
    if (carrierId) {
      breadcrumbHref = `/carriers/${carrierId}/contents/${contentId}`;
    }

    return (
      <Page
        breadcrumbs={[{ content: 'View Content', href: breadcrumbHref }]}
        title="Advanced Edit Content"
      >
        <ContentForm contentId={contentId} getScope={this.handleGetScope} />
        <Box marginTop="10px">
          <Button
            variant="danger"
            primary
            onClick={() => this.setState({ deleteConfirmationOpen: !deleteConfirmationOpen })}
          >
            Delete Content
          </Button>
          <DeleteContent
            closeHandler={this.handleCloseHandler}
            isOpen={deleteConfirmationOpen}
            deleteHandler={this.handleDeleteContent}
            deleteError={deleteError}
          />
        </Box>
      </Page>
    );
  }
}
EditContent.propTypes = propTypes;
export default EditContent;
